<shig-header class="lay-wrapper lay-wrapper--header" />

<div class="lay-wrapper lay-wrapper--main main-content">
    <router-outlet #outlet="outlet" />
</div>

<shig-footer id="footer-mygr" />
